/**
 * @readonly
 * @enum {string}
 */
export const GameLoginModes = {
  Anonymous: "anonymous",
  EmailAndNames: "emailAndNames"
}
